import { GetterTree } from "vuex";

import { UserState } from "@/models/UserState.d.ts";
import { Language } from "@/models/Language.d.ts";
import { LOCALES } from "@/i18n/locales";
import {Avatar} from "@/models/Avatar";

export const getters: GetterTree<UserState, {}> = {
    isAuthenticated(state: UserState): boolean {
        return !!state.accessToken;
    },
    userName(state: UserState): string {
        return state.user ? state.user?.username : "";
    },
    userAvatar(state: UserState): Avatar {
        if (state.user && state.user.avatar && state.user.avatar.avatar){
            return state.user.avatar;
        } else {
            return {avatar: ''};
        }
    },
    userRawAvatar(state: UserState): string {
        if (state.user && state.user.avatar && state.user.avatar.avatar){
            return state.user.avatar.avatar;
        } else {
            return '';
        }
    },
    userFirstName(state: UserState): string {
        const firstName = state.user ? state.user?.first_name : "";
        return firstName;
    },
    userLastName(state: UserState): string {
        const lastName = state.user ? state.user?.last_name : "";
        return lastName;
    },
    userEmail(state: UserState): string {
        const email = state.user ? state.user?.email : "";
        return email;
    },
    fullName(state: UserState): string {
        const firstName = state.user ? state.user?.first_name : "";
        const lastName =  state.user ? state.user?.last_name : "";

        return firstName + " " + lastName;
    },
    errorMsg(state: UserState): string {
        return state.errorMsg ? state.errorMsg : "";
    },
    errorCode(state: UserState): number {
        return state.errorCode ? state.errorCode : 0;
    },
    userLanguageId(state: UserState): Language {
        //Language id that came from the backend or the index 0 in the LOCALES array in i18n
        return state.user ? state.user.language : LOCALES[0];
    },
    terms(state: UserState): string {
        return state.terms ? state.terms : "";
    },
    userSource(state: UserState): number {
        return state.user?.source ? state.user.source : 0;
    },
    forceReset(state: UserState): boolean {
        return !!state.user?.forceReset;
    },
    isVideoPlaying(state: UserState): boolean {
        return state.isPlayingVideo ?? false;
    }
};
